import classNames from "classnames";
import { ChangeEventHandler } from "react";
import "./style.css";

interface TextAreaProps {
    label: any;
    value?: string;
    onChange: ChangeEventHandler<HTMLTextAreaElement>;
    maxLength?: number;
    rows?: number;
    className?: string;
}

export const TextArea = ({
    label,
    value,
    onChange,
    maxLength,
    rows,
    className,
}: TextAreaProps) => (
    <>
        <label>{label}</label>
        <div>
            <textarea
                className={classNames("c-TextArea", className)}
                maxLength={maxLength}
                rows={rows}
                value={value}
                onChange={onChange}
            />
        </div>
    </>
);
